module.exports = __webpack_public_path__ + "static/media/13.d3e29eb2.jpg";